export enum DiceTypes {
  CUP = 'cup',
  DICE = 'dice'
}

export enum DiceTriggerType {
  BUTTON = 'button',
  CUP = 'cup'
}
